import React, { useEffect, useMemo, useState } from "react";
import { DataTable, BestSelect } from "best-common-react";
import UserApi from "../../../httpClients/UserApi";
import { AuthConstants } from "../../../constants/AuthConstants";

const ALL_ROLES_VALUE = "ALL";

const USER_ROLE_SELECT_OPTIONS = [
  ...Object.values(AuthConstants.ROLES).map((role) => ({
    value: role,
    label: role,
  })),
];

const ROLE_FILTER_SELECT_OPTIONS = [{ value: ALL_ROLES_VALUE, label: "All Roles" }, ...USER_ROLE_SELECT_OPTIONS];

const selectStyles = {
  container: {
    height: "36px",
    fontSize: "14px",
  },
  control: {
    height: "36px",
    minHeight: "32px",
  },
  valueContainer: {
    padding: "0 8px 0px 8px",
  },
};

const ClubCellFormatter = ({ row }) => {
  const label = row.club?.name || row.club?.abbr || "";
  return <div>{label}</div>;
};

const UsersTable = () => {
  const [users, setUsers] = useState([]);
  const [selectedRoleFilter, setSelectedRoleFilter] = useState(ROLE_FILTER_SELECT_OPTIONS[0]);

  useEffect(() => {
    UserApi.getAllUsers()
      .then((data) => {
        setUsers(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        setUsers([]);
      });
  }, []);

  const filteredUsers = useMemo(() => {
    if (selectedRoleFilter?.value === ALL_ROLES_VALUE) {
      return users;
    }

    return users.filter((user) => user.role === selectedRoleFilter?.value);
  }, [users, selectedRoleFilter]);

  const RoleFormatter = ({ row }) => {
    const current = row.role ?? NONE_ROLE;
    const selected = USER_ROLE_SELECT_OPTIONS.find((o) => o.value === current) ?? USER_ROLE_SELECT_OPTIONS[0];
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <BestSelect
          options={USER_ROLE_SELECT_OPTIONS}
          value={selected}
          onChange={(opt) => {
            const updatedUser = { ...row, role: opt?.value ?? NONE_ROLE };
            UserApi.saveUser(updatedUser).then((savedUser) => {
              setUsers((prev) => prev.map((u) => (u.id === savedUser.id ? savedUser : u)));
            });
          }}
          portal={document.body}
          styles={selectStyles}
          placeHolder="Role"
          onClick={() => {}}
          clearable={false}
        />
      </div>
    );
  };

  const columns = [
    {
      key: "email",
      name: "Email",
    },
    {
      key: "role",
      name: "Role",
      width: 200,
      formatter: RoleFormatter,
    },
    {
      key: "club",
      name: "Club",
      formatter: ClubCellFormatter,
    },
  ];

  return (
    <div className="mt-2">
      <div className="mb-2" style={{ width: "220px" }}>
        <BestSelect
          options={ROLE_FILTER_SELECT_OPTIONS}
          placeHolder="Filter by role"
          value={selectedRoleFilter}
          onChange={(option) => setSelectedRoleFilter(option ?? ROLE_FILTER_SELECT_OPTIONS[0])}
          styles={selectStyles}
          onClick={() => {}}
          clearable={false}
        />
      </div>
      <DataTable
        id="users-settings-table"
        columns={columns}
        data={filteredUsers}
        minHeight={400}
        rowHeight={40}
        headerRowHeight={40}
      />
    </div>
  );
};

export default UsersTable;
